import { GetPatientsBalanceResponse_PatientBalance } from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { Filters } from 'react-table';
import { theme } from '@frontend/theme';
import { Button, Dot, PopoverDialog, usePopoverDialog } from '@frontend/design-system';
import { CollectionFilterMenu } from './collection-filter-menu';

type CollectionFilterButtonProps = {
  handleFilter: ({ key, val }: { key: string; val: string }) => void;
  selectedFilters: Filters<GetPatientsBalanceResponse_PatientBalance>;
};
export const CollectionFilterButton = ({ handleFilter, selectedFilters }: CollectionFilterButtonProps) => {
  const { getDialogProps, getTriggerProps } = usePopoverDialog({
    placement: 'bottom-end',
  });

  return (
    <>
      <Button
        variant='tertiary'
        data-trackingid='collection-filterButton'
        size='large'
        iconName='filter-alt'
        css={{
          svg: {
            color: theme.colors.black,
          },
          position: 'relative',
        }}
        {...getTriggerProps()}
      >
        {selectedFilters.length > 0 && (
          <Dot
            color='primary'
            css={{
              width: theme.spacing(1.5),
              height: theme.spacing(1.5),
              top: 4,
              right: 4,
              border: `1.5px solid ${theme.colors.white}`,
            }}
          />
        )}
      </Button>
      <PopoverDialog {...getDialogProps()} css={{ minWidth: 300, padding: 0, borderRadius: theme.borderRadius.medium }}>
        <CollectionFilterMenu handleFilter={handleFilter} selectedFilters={selectedFilters} />
      </PopoverDialog>
    </>
  );
};
